module.exports = __webpack_public_path__ + "img/202603_04.bcb48e34.png";